var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullCalendar',{attrs:{"defaultView":"dayGridMonth","plugins":_vm.calendarPlugins,"header":_vm.header,"locale":_vm.calendarLocal,"locales":_vm.locales,"eventRender":_vm.eventRender,"events":_vm.events}})
}
var staticRenderFns = []

export { render, staticRenderFns }